import { useQuery } from 'react-query';
import {
    getPositionTitles,
    getPositionTechStacks,
    getTechStacksForPositionTitle,
    getSkillsForTechStack,
    GetPositionTitlesAPIResponse,
    GetPositionTechStacksAPIResponse,
    GetSkillsForTechStackAPIResponse,
} from 'src/apis/positionConfiguration';

export const useGetPositionTitlesQuery = () => {
    return useQuery<GetPositionTitlesAPIResponse>(
        ['getPositionTitles'],
        () => getPositionTitles(),
        {
            staleTime: 5 * 60 * 1000, // 5 minutes
            cacheTime: 10 * 60 * 1000, // 10 minutes
        },
    );
};

export const useGetPositionTechStacksQuery = () => {
    return useQuery<GetPositionTechStacksAPIResponse>(
        ['getPositionTechStacks'],
        () => getPositionTechStacks(),
        {
            staleTime: 5 * 60 * 1000, // 5 minutes
            cacheTime: 10 * 60 * 1000, // 10 minutes
        },
    );
};

export const useGetTechStacksForPositionTitleQuery = (positionTitleId: string | null | undefined, enabled: boolean = true) => {
    return useQuery<GetPositionTechStacksAPIResponse>(
        ['getTechStacksForPositionTitle', positionTitleId],
        () => getTechStacksForPositionTitle(positionTitleId!),
        {
            enabled: enabled && !!positionTitleId,
            staleTime: 5 * 60 * 1000, // 5 minutes
            cacheTime: 10 * 60 * 1000, // 10 minutes
        },
    );
};

export const useGetSkillsForTechStackQuery = (techStackId: string | null | undefined, enabled: boolean = true) => {
    return useQuery<GetSkillsForTechStackAPIResponse>(
        ['getSkillsForTechStack', techStackId],
        () => getSkillsForTechStack(techStackId!),
        {
            enabled: enabled && !!techStackId,
            staleTime: 5 * 60 * 1000, // 5 minutes
            cacheTime: 10 * 60 * 1000, // 10 minutes
        },
    );
};

